module.exports = __webpack_public_path__ + "fb29c675794b08e2ed1fbdd030378ef0.png";